import React from 'react';
import { useTranslation } from 'react-i18next';
import { array, bool, object } from 'prop-types';

import useStyles from 'hooks/useStyles';

import InstructorProfile from 'components/InstructorProfile';
import { COURSE, COURSE_LESSON } from 'constants/contentTypes';

import styles from './Instructor.scss';

function Instructor({ elementRef, instructors, isLessonPage }) {
  useStyles(styles);
  const { t } = useTranslation(['course']);

  return (
    <section ref={elementRef}>
      <h2 className={styles.title}>{t('videoplayer.label.instructor')}</h2>
      <InstructorProfile
        instructors={instructors}
        contentType={isLessonPage ? COURSE_LESSON : COURSE}
      />
    </section>
  );
}

Instructor.propTypes = {
  elementRef: object.isRequired,
  instructors: array.isRequired,
  isLessonPage: bool.isRequired,
};

export default Instructor;
